import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Version banner - will show immediately when this file loads
console.log('%c🚀 FIND TIME v2.0 - BUILD: ' + new Date().toISOString(), 'background: #222; color: #bada55; font-size: 16px; font-weight: bold; padding: 10px;');
console.log('%cIndex calculation bug FIX deployed', 'background: #0066cc; color: white; font-size: 12px; padding: 5px;');

// Initialize the app
const root = ReactDOM.createRoot(document.getElementById('root')!);

// If Office.js is available, wait for it to be ready
if (typeof Office !== 'undefined') {
  Office.onReady(() => {
    console.log('Office.js is ready');
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
} else {
  // For development/testing without Office.js
  console.log('Running without Office.js');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
